/* @flow */
import React from 'react';
import Text from 'components/Text.jsx';

import cx from 'classnames';

import './styles/StatusLabel.scss';

class StatusLabel extends React.Component {
  render() {
    return (
      <Text
        {...this.props}
        className={cx('StatusLabel', this.props.className)}
        color="thunder">
        {this.props.children}
      </Text>
    );
  }
}

export default StatusLabel;



// WEBPACK FOOTER //
// ./src/components/StatusLabel.jsx